module.exports = __webpack_public_path__ + "media/components/assets/img/flag/uk-aa60615b955aa216bd7d52f19cbbaeca.svg";